import { useRef, useEffect } from 'react';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import generatePowerInvoice from '../utils/generatePowerInvoice';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const PowerInvoice = ({ data, formData, number }) => {
  const iframeContainer = useRef();

  useEffect(() => {
    const { pdfMakeObject: invoiceDefinition } = generatePowerInvoice(
      data,
      formData,
      number
    );
    const pdfDocGenerator = pdfMake.createPdf(invoiceDefinition);
    pdfDocGenerator.getDataUrl((dataUrl) => {
      iframeContainer.current.innerHTML = '';
      const iframe = document.createElement('iframe');
      iframe.setAttribute('style', 'width: 100%; height: 800px');
      iframe.src = dataUrl;
      iframeContainer.current.appendChild(iframe);
    });
  }, [data, formData, number]);

  return <div ref={iframeContainer} />;
};

export default PowerInvoice;
